class InfiniteScroll {
    constructor(options = {}) {
      this.productGridSelector = options.productGridSelector || '#product-grid';
      this.productGrid = document.querySelector(this.productGridSelector);
      this.currentPage = 1;
      this.isLoading = false;
      this.hasMorePages = true;
      
      this.init();
    }
  
    init() {
      // Create and append loading indicator
      this.loadingIndicator = document.createElement('div');
      this.loadingIndicator.className = 'loading-indicator hidden';
      this.loadingIndicator.innerHTML = '<div class="loading-spinner"></div>';
      this.productGrid.insertAdjacentElement('afterend', this.loadingIndicator);
  
      // Add scroll event listener
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }
  
    handleScroll() {
      if (this.isLoading || !this.hasMorePages) return;
  
      const productGridRect = this.productGrid.getBoundingClientRect();
      const scrollPosition = window.innerHeight + window.scrollY;
      const loadTriggerPosition = productGridRect.top + (productGridRect.height / 2);
  
      if (scrollPosition >= loadTriggerPosition) {
        this.loadNextPage();
      }
    }
  
    async loadNextPage() {
      try {
        this.isLoading = true;
        this.loadingIndicator.classList.remove('hidden');
  
        // Construct URL for next page
        const url = new URL(window.location.href);
        this.currentPage++;
        url.searchParams.set('page', this.currentPage);
        
        // Fetch next page
        const response = await fetch(url.toString(), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
  
        if (!response.ok) throw new Error('Failed to load more products');
  
        const html = await response.text();
        
        // Parse the new products from the response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelector(this.productGridSelector);
  
        const validProducts = newProducts ? newProducts.querySelectorAll('li.grid__item:not(.quality-card):not(.collection-tile)') : [];
        if (validProducts.length > 0) {
          // Append new products to the grid
          Array.from(validProducts).forEach(product => {
            this.productGrid.appendChild(product.cloneNode(true));
          });
        } else {
          // No more products to load
          this.hasMorePages = false;
          this.loadingIndicator.remove();
          console.log('No more products to load. Infinite scroll stopped.');
        }
  
      } catch (error) {
        console.error('Error loading more products:', error);
        this.hasMorePages = false;
      } finally {
        this.isLoading = false;
        this.loadingIndicator.classList.add('hidden');
      }
    }
  }

  /*
  Disabled bcs AB-Test
  document.addEventListener('DOMContentLoaded', () => {
    new InfiniteScroll({
      productGridSelector: '#product-grid'
    });
  });*/
  